import React from 'react';
import {StyledAvailabilityRow} from "@app/availabilityPage/panes/availability.style";
import moment from "moment/moment";
import {Availability} from "@models/calendar";
import {useTranslation} from "react-i18next";
import {formatDurationHuman} from "@services/calendar/availability.service";

type AvailabilityEventProps = {
    availability: Availability,
    onClick: () => void,
}

const AvailabilityEvent: React.FC<AvailabilityEventProps> = ({availability, onClick}: AvailabilityEventProps) => {
    const {t} = useTranslation();

    return (
        <StyledAvailabilityRow type="availability" onClick={onClick}>
            <div className="time">{moment(availability.startTime).format('HH:mm')} - {moment(availability.endTime).format('HH:mm')}</div>
            <div className="content">
                <div className="info">
                    <span>{t('availability.title')} - {formatDurationHuman(availability.attributes.duration)}</span>
                </div>
            </div>
        </StyledAvailabilityRow>
    );
};

export default AvailabilityEvent;
